// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_93444fe79c--wrapper--AZAmS","header":"_93444fe79c--header--q8cEB","text":"_93444fe79c--text--Tdyv1","emoji":"_93444fe79c--emoji--rxhNJ"};